export default __webpack_public_path__ + "static/media/hallway.66dca66e.webp";